import React from "react";
import { useNavigate } from "react-router-dom";
import "./Header.css";
import netflixLogo from "./assets/netflix.png"; // logo Netflix
import { FaUserCircle, FaSignOutAlt } from "react-icons/fa"; // ikon user & logout

export default function Header({ onLogout }) {
  const navigate = useNavigate();

  return (
    <header className="app-header d-flex justify-content-between align-items-center px-3 py-2 shadow-sm bg-white">
      {/* Logo & Title */}
      <div className="d-flex align-items-center">
        <img
          src={netflixLogo}
          alt="Netflix Logo"
          className="logo-img me-2"
          style={{ height: "40px" }}
        />
        <h5 className="text-danger fw-bold mb-0">NetflixVIP</h5>
      </div>

      {/* Icon Buttons */}
      <div className="d-flex align-items-center">
        {/* Tombol Profile */}
        <button
          className="btn btn-link text-danger fs-4 me-3"
          title="My Profile"
          onClick={() => navigate("/viewpersonal")}
        >
          <FaUserCircle />
        </button>

        {/* Tombol Logout */}
        <button
          className="btn btn-link text-danger fs-4"
          title="Logout"
          onClick={onLogout}
        >
          <FaSignOutAlt />
        </button>
      </div>
    </header>
  );
}
